import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { getSelectedProduct } from 'ducks/products';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Box from 'ui/Box';
import Body from 'ui/Typography/Body';
import { getProductDimensionsForNarration } from 'utils/measurementUtils';

// A minimum height is needed to ensure that the component does not change height briefly
// when a new product is selected in the scene while selected menu is open and the
// dimensions are not available yet. Often this component is used in the top of a menu
// and if it changes height, all the other components in the menu will have a jumping behavior.
const StyledBody = styled(Body)`
  min-height: 1.5rem;
`;

const DimensionsLabel = () => {
  const selectedProduct = useSelector(getSelectedProduct);
  const { formatMessage } = useIntl();
  const dimensions =
    selectedProduct?.communicatedSizeText ||
    `${selectedProduct?.communicatedDimensionsLocalized.width}x${selectedProduct?.communicatedDimensionsLocalized.depth}x${selectedProduct?.communicatedDimensionsLocalized.height} ${selectedProduct?.communicatedDimensionsLocalized.unit}`;

  return (
    <Box mb="s">
      <StyledBody
        type={ThemeFontStyleTypeEnum.bodyMedium}
        aria-label={getProductDimensionsForNarration(formatMessage, selectedProduct)}
        data-testid="dimensions-label"
      >
        {dimensions}
      </StyledBody>
    </Box>
  );
};

export default DimensionsLabel;
